import "./index.css";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { LoadingOverlay } from "@/components/loading-overlay";
import { MainPage } from "@/components/main-page";
import { OnboardingPage } from "@/components/onboarding-page";
import { RealtimeCursors } from "@/components/realtime-cursors";
import { useStoreSynced } from "@/lib/store-synced";

export function App() {
  const {
    clientSelf,
    clientReady,
    clientStatusReady,
    clientsSubscribe,
    clientStatusChannel,
    clientStatusesSubscribe,
  } = useStoreSynced(
    useShallow((s) => ({
      clientSelf: s.clientSelf,
      clientReady: s.clientReady,
      clientStatusReady: s.clientStatusReady,
      clientsSubscribe: s.clientsSubscribe,
      clientStatusChannel: s.clientStatusChannel,
      clientStatusesSubscribe: s.clientStatusesSubscribe,
    })),
  );

  useEffect(() => {
    const clientsUnsubscribe = clientsSubscribe();
    return () => {
      clientsUnsubscribe();
    };
  }, [clientsSubscribe]);

  useEffect(() => {
    const clientStatusesUnsubscribe = clientStatusesSubscribe(
      clientStatusChannel,
      clientSelf?.podNumber ?? null,
    );
    return () => {
      clientStatusesUnsubscribe();
    };
  }, [clientStatusesSubscribe, clientSelf, clientStatusChannel]);

  const isReady =
    clientReady && (clientSelf?.onboarded ? clientStatusReady : true);

  return (
    <div className="h-screen w-screen">
      <LoadingOverlay isDone={isReady} />
      <RealtimeCursors />
      {clientSelf?.onboarded !== true ? <OnboardingPage /> : <MainPage />}
    </div>
  );
}

export default App;
